import postFetcher from 'api/utils/postFetcher';
import { useCallback } from 'react';
import type { LegacyOrderData } from 'types/legacyDashboard';

interface UsePurchasePhoneNumberProps {
  deviceId?: DeviceId;
  organizationId?: OrgId;
}

interface PurchasePhoneNumberBody {
  areacode?: number;
  country: string;
}

interface PurchasePhoneNumberReturn {
  order_data: LegacyOrderData;
  success: boolean;
  data: string; // New phone number. E.g. "+16086368247"
  error?: string;
}

const usePurchasePhoneNumber = ({ deviceId, organizationId }: UsePurchasePhoneNumberProps) => {
  const queryParams = new URLSearchParams({ orgid: `${organizationId}` });
  const url =
    deviceId && organizationId
      ? `${process.env.VITE_API_ROOT}/devices/${deviceId}/addnumber?${queryParams}`
      : null;

  const callback = useCallback(
    async (country: string, areaCode: number | undefined = undefined) => {
      if (!url) {
        return undefined;
      }

      const result: PurchasePhoneNumberReturn | undefined =
        await postFetcher<PurchasePhoneNumberBody>({
          url,
          body: { areacode: areaCode, country },
          throwOnError: false,
        });

      return result;
    },
    [url]
  );

  return callback;
};

export default usePurchasePhoneNumber;
